export const versions = {
  assets: '4.14.0', // needs manual update when upgrading dependencies
  core: '7.79.1', // don't change. value is updated automatically
  fonts: '2.1.0', // needs manual update when upgrading dependencies
};
